module.exports = __webpack_public_path__ + "static/assets/7ce197172287887ac173f361ca360f02.png";